import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ProductCommentPictureComponentV2 from "./ProductCommentPictureComponent/ProductCommentPictureComponentV2";
import { useTranslation } from "react-i18next";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

function ProductCommentPhotoApprovalV2({
  photoModelList,
  setSelectedPhotoModelList,
  approvalStatuses,
  setApprovalStatuses,
  rejectionReasons,
  setRejectionReasons,
  rejectionReasonLookupList,
}: any) {
  const { t } = useTranslation();
  const [selectOptions, setSelectOptions] = useState<any[]>([]);

  useEffect(() => {
    if (rejectionReasonLookupList && rejectionReasonLookupList.length > 0) {
      setSelectOptions(
        rejectionReasonLookupList.map((reason: any) => ({
          value: reason.id,
          label: reason.reasonForRejection,
        }))
      );
    }
  }, [rejectionReasonLookupList]);
  useEffect(() => {
    const initialStatuses: { [key: string]: string } = {};
    photoModelList.forEach((photoModel: any) => {
      initialStatuses[photoModel.imageId] =
        photoModel.status === 2 ? "approved" : "rejected";
    });
    setApprovalStatuses(initialStatuses);
  }, [photoModelList, setApprovalStatuses]);

  useEffect(() => {
    const initialSelectedPhotos = photoModelList.map((photoModel: any) => ({
      ImageId: photoModel.imageId,
      Status: photoModel.status === 2 ? "2" : "3",
      Reasons: rejectionReasons[photoModel.imageId] || [],
    }));
    setSelectedPhotoModelList(initialSelectedPhotos);
  }, [photoModelList, setSelectedPhotoModelList]);

  useEffect(() => {
    const initialRejectionReasons: { [key: string]: string[] } = {};

    photoModelList.forEach((photoModel: any) => {
      if (photoModel.rejectedCommentReasonId) {
        initialRejectionReasons[photoModel.imageId] = [
          photoModel.rejectedCommentReasonId.toString(),
        ];
      } else {
        initialRejectionReasons[photoModel.imageId] = [];
      }
    });

    setRejectionReasons(initialRejectionReasons);
  }, [photoModelList, setRejectionReasons]);

  const handleApprovalChange = (
    photoId: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const status = event.target.value;
    setApprovalStatuses((prevStatuses: any) => {
      const updatedStatuses = {
        ...prevStatuses,
        [photoId]: status,
      };
      const updatedRejectionReasons = { ...rejectionReasons };
      if (status === "approved") {
        updatedRejectionReasons[photoId] = [];
      }

      const updatedPhotoList = photoModelList.map((photoModel: any) => ({
        ImageId: photoModel.imageId,
        Status: updatedStatuses[photoModel.imageId] === "approved" ? "2" : "3",
        Reasons:
          updatedStatuses[photoModel.imageId] === "approved"
            ? []
            : updatedRejectionReasons[photoModel.imageId] || [],
      }));
      setRejectionReasons(updatedRejectionReasons);
      setSelectedPhotoModelList(updatedPhotoList);
      return updatedStatuses;
    });
  };
  const handleRejectionReasonChange = (photoId: string, event: any) => {
    const { value } = event.target;
    setRejectionReasons((prevReasons: any) => ({
      ...prevReasons,
      [photoId]: [value],
    }));
  };

  useEffect(() => {
    const updatedPhotoList = photoModelList.map((photoModel: any) => ({
      ImageId: photoModel.imageId,
      Status: approvalStatuses[photoModel.imageId] === "approved" ? "2" : "3",
      Reasons: rejectionReasons[photoModel.imageId] || [],
    }));
    setSelectedPhotoModelList(updatedPhotoList);
  }, [rejectionReasons, photoModelList, approvalStatuses]);

  return (
    <Grid
      container
      spacing={4}
      sx={{
        width: "100%",
        maxWidth: "100%",
        py: 2,
        px: 0,
        justifyContent: "flex-start",
        boxSizing: "border-box",
      }}
    >
      {photoModelList &&
        photoModelList.map((photoModel: any) => (
          <Grid
            key={photoModel.imageId}
            size={{
              xs: 12,
              sm: 6,
              lg: 4,
            }}
            sx={{ display: "flex", minWidth: 0 }}
          >
            <Box
              sx={{
                width: "100%",
                p: 2,
                borderRadius: "20px",
                border: "1px solid rgba(148, 163, 184, 0.22)",
                backgroundColor: "#fff",
                boxShadow: "0 14px 32px rgba(15, 23, 42, 0.08)",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                "&:hover": {
                  transform: "translateY(-3px)",
                  boxShadow: "0 18px 36px rgba(15, 23, 42, 0.12)",
                },
              }}
            >
              <Box sx={{ textAlign: "center" }}>
              <ProductCommentPictureComponentV2
                photoModel={{
                  photoUrl: photoModel.imageUrl,
                  photoName: photoModel.photoName,
                  photoId: photoModel.imageId,
                  selectedCheckbox: photoModel.selectedCheckbox,
                  selectOptions: photoModel.selectOptions,
                }}
              />
              </Box>
              <Grid sx={{ mt: 2 }}>
                <FormControl component="fieldset">
                  <FormLabel
                    component="legend"
                    sx={{
                      fontWeight: 700,
                      color: "#334155",
                      fontSize: "0.95rem",
                      mb: 0.5,
                    }}
                  >
                    Onay Durumu
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-label="approval"
                    name={`approval-${photoModel.imageId}`}
                    value={approvalStatuses[photoModel.imageId] || ""}
                    onChange={(event) =>
                      handleApprovalChange(photoModel.imageId, event)
                    }
                  >
                    <FormControlLabel
                      value="approved"
                      control={<Radio color="primary" />}
                      label={
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          <CheckCircleOutlineRoundedIcon color="primary" sx={{ fontSize: 18 }} />
                          <Typography sx={{ fontWeight: 600, fontSize: "0.95rem" }}>Onay</Typography>
                        </Box>
                      }
                    />
                    <FormControlLabel
                      value="rejected"
                      control={<Radio color="error" />}
                      label={
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          <CancelOutlinedIcon color="error" sx={{ fontSize: 18 }} />
                          <Typography sx={{ fontWeight: 600, fontSize: "0.95rem" }}>Ret</Typography>
                        </Box>
                      }
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Chip
                size="small"
                label={approvalStatuses[photoModel.imageId] === "approved" ? "Onaylandı" : "Ret Bekliyor"}
                color={approvalStatuses[photoModel.imageId] === "approved" ? "success" : "error"}
                variant={approvalStatuses[photoModel.imageId] === "approved" ? "filled" : "outlined"}
                sx={{ mt: 1.5, fontWeight: 700 }}
              />
              {/* Eğer fotoğraf reddedilmişse, ret nedenleri göster */}
              {approvalStatuses[photoModel.imageId] === "rejected" && (
                <Tooltip
                  title={
                    rejectionReasons[photoModel.imageId] &&
                    rejectionReasons[photoModel.imageId].length > 0 ? (
                      <ul style={{ margin: 0, padding: "0 0 0 20px" }}>
                        {rejectionReasons[photoModel.imageId].map(
                          (reason: any, index: any) => (
                            <li key={index}>
                              {
                                selectOptions.find(
                                  (option) => option.value === reason
                                )?.label
                              }
                            </li>
                          )
                        )}
                      </ul>
                    ) : (
                      t("general.select")
                    )
                  }
                >
                  <Box
                    sx={{
                      mt: 2,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Select
                      labelId="rejection-reason-select-label"
                      value={rejectionReasons[photoModel.imageId] || ""}
                      onChange={(event) =>
                        handleRejectionReasonChange(photoModel.imageId, event)
                      }
                      sx={{
                        width: "100%",
                        maxWidth: "100%",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        borderRadius: "14px",
                        backgroundColor: "rgba(248, 250, 252, 0.95)",
                      }}
                      displayEmpty
                    >
                      <MenuItem disabled value="">
                        {t("general.select")}
                      </MenuItem>
                      {selectOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          <Checkbox
                            checked={
                              Array.isArray(
                                rejectionReasons[photoModel.imageId]
                              ) &&
                              rejectionReasons[photoModel.imageId].includes(
                                option.value
                              )
                            }
                          />
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Tooltip>
              )}
            </Box>
          </Grid>
        ))}
    </Grid>
  );
}

export default ProductCommentPhotoApprovalV2;
